<template>
  <div class="passes-selector">
    <h4 class="w-full mb-3">Passes</h4>
    <div class="passes-list w-full" v-if="getPassEntries && Object.keys(getPassEntries).length">
      <ul class="ml-5">
        <li class="my-3" v-for="(pass, index) in passesList" :key="index">
          <vs-checkbox
            @change="(e) => handleCheckbox(e, pass)"
            :class="`with-dots ${passesIds.includes(pass.id) ? 'selected' : ''}`"
            v-model="passesSelected"
            :vs-value="pass">{{pass.name}}
          </vs-checkbox>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    passes: Array,
    type: String,
    entityId: String
  },
  data () {
    return {
      passesSelected: []
    }
  },
  computed: {
    ...mapGetters('courses', ['getCurrentCourse', 'getCourseStatusList']),
    ...mapGetters('lpaths', ['getCurrentLPath', 'getLPathStatusList']),
    ...mapGetters('bootcamps', ['getCurrentBootcamp', 'getBootcampStatusList']),
    ...mapGetters('passes', ['getPassEntries']),
    passesIds() {
      return this.passes
    },
    passesList() {
      return Object.values(this.getPassEntries).map(pass => {
        return {
          id: pass.id,
          name: pass.name
        }
      })
    }
  },
  methods: {
    // @ToDo, use vsPrompt instead $vs.dialog and delete white-space: pre-wrap.
    ...mapActions("passes", ['saveCourseToPass', 'removeCourseFromPass', "getAllPasses", 'saveLPathToPass', 'removeLPathFromPass', 'saveBootcampToPass', 'removeBootcampFromPass']),
    handleCheckbox(e, pass) {
      if (e.target) {
        if (e.target.checked) {
          this.preAddPass(e, pass)
        } else {
          this.preDeletePass(e, pass)
        }
      }
    },
    preAddPass(e, pass) {
      switch (this.type) {
        case 'Course':
          if (this.getCurrentCourse.status === this.getCourseStatusList.PUBLISHED) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `WARNING: This course is already published.`,
              text: '\nAdding passes could prevent users from getting access to it.\n\nAre you sure you want to make this change?',
              accept: () => {this.addPass(pass)},
              cancel: () => {this.passesSelected.splice(-1,1)}
            })
          } else {
            this.addPass(pass)
          }
          break
        case 'Learning Path':
          if (this.getCurrentLPath.status === this.getLPathStatusList.PUBLISHED) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `WARNING: This learning path is already published.`,
              text: '\nAdding passes could prevent users from getting access to it.\n\nAre you sure you want to make this change?',
              accept: () => {this.addPass(pass)},
              cancel: () => {this.passesSelected.splice(-1,1)}
            })
          } else {
            this.addPass(pass)
          }
          break
        case 'Bootcamp':
          if (this.getCurrentBootcamp.status === this.getBootcampStatusList.PUBLISHED) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `WARNING: This bootcamp is already published.`,
              text: '\nAdding passes could prevent users from getting access to it.\n\nAre you sure you want to make this change?',
              accept: () => {this.addPass(pass)},
              cancel: () => {this.passesSelected.splice(-1,1)}
            })
          } else {
            this.addPass(pass)
          }
          break
        default:
          break;
      }
    },
    preDeletePass(e, pass) {
      switch (this.type) {
        case 'Course':
          if (this.getCurrentCourse.status === this.getCourseStatusList.PUBLISHED) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `WARNING: This course is already published.`,
              text: '\nRemoving passes could prevent users from getting access to it.\n\nAre you sure you want to make this change?',
              accept: () => {this.deletePass(pass)},
              cancel: () => {this.passesSelected.push(pass)}
            })
          } else {
            this.deletePass(pass)
          }
          break
        case 'Learning Path':
          if (this.getCurrentLPath.status === this.getLPathStatusList.PUBLISHED) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `WARNING: This learning path is already published.`,
              text: '\nRemoving passes could prevent users from getting access to it.\n\nAre you sure you want to make this change?',
              accept: () => {this.deletePass(pass)},
              cancel: () => {this.passesSelected.push(pass)}
            })
          } else {
            this.deletePass(pass)
          }
          break
        case 'Bootcamp':
          if (this.getCurrentBootcamp.status === this.getBootcampStatusList.PUBLISHED) {
            this.$vs.dialog({
              type: 'confirm',
              color: 'warning',
              title: `WARNING: This bootcamp is already published.`,
              text: '\nRemoving passes could prevent users from getting access to it.\n\nAre you sure you want to make this change?',
              accept: () => {this.deletePass(pass)},
              cancel: () => {this.passesSelected.push(pass)}
            })
          } else {
            this.deletePass(pass)
          }
          break
        default:
          break;
      }
    },
    async addPass(pass) {
      try {
        if (!this.passesIds.includes(pass.id)) {
          this.$vs.loading()
          switch (this.type) {
            case 'Course':
              await this.saveCourseToPass({
                course_ids: [this.entityId],
                passId: pass.id,
                item: {id: pass.id, name: pass.name}
              })
              break;
            case 'Learning Path':
              await this.saveLPathToPass({
                lpath_ids: [this.entityId],
                passId: pass.id,
                item: {id: pass.id, name: pass.name}
              })
              break;
            case 'Bootcamp':
              await this.saveBootcampToPass({
                bootcamp_ids: [this.entityId],
                passId: pass.id,
                item: {id: pass.id, name: pass.name}
              })
              break;
            default:
              break;
          }
          this.$vs.loading.close()
          this.$vs.notify({
            title: "Success",
            text: `${this.type} added to pass`,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        }
      } catch (error) {
        this.showError(error)
      }
    },
    async deletePass(pass) {
      try {
        if (this.passesIds.includes(pass.id)) {
          this.$vs.loading()
          
          switch (this.type) {
          case 'Course':
            await this.removeCourseFromPass({
              courseId: this.entityId,
              passId: pass.id,
              item: {id: pass.id, name: pass.name}
            })
            break;
          case 'Learning Path':
            await this.removeLPathFromPass({
              lpathId: this.entityId,
              passId: pass.id,
              item: {id: pass.id, name: pass.name}
            })
            break;
          case 'Bootcamp':
            await this.removeBootcampFromPass({
              bootcampId: this.entityId,
              passId: pass.id,
              item: {id: pass.id, name: pass.name}
            })
            break;
          default:
            break;
        }
          this.$vs.loading.close()
          this.$vs.notify({
            title: "Success",
            text: `${this.type} deleted from pass`,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
        }
      } catch (error) {
        this.showError(error)
      }
    }
  },
  async created() {
    await this.getAllPasses()
    this.passesSelected = this.passesList.reduce((acc, pass) => {
      if (this.passesIds.includes(pass.id)) {
        acc.push(pass)
      }
      return acc
    }, [])
  },
  watch: {
    passes: function () {
      this.passesSelected = this.passesList.reduce((acc, pass) => {
        if (this.passesIds.includes(pass.id)) {
          acc.push(pass)
        }
        return acc
      }, [])
    }
  }
}
</script>